<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import AppOverlay from '@/components/ui/AppOverlay.vue'
import { availableAppUpdate, applyAvailableAppUpdate } from '@/services/appUpdater'
import { useAppUpdatePrompt } from '@/composables/useAppUpdatePrompt'

const { t } = useI18n()
const { open } = useAppUpdatePrompt(computed(() => availableAppUpdate.value?.id))
const updating = ref(false)
const failed = ref(false)

async function updateNow() {
  if (updating.value) return
  updating.value = true
  failed.value = false
  try {
    await applyAvailableAppUpdate()
  } catch (error) {
    console.warn('[OTA] unable to activate update:', error)
    failed.value = true
    updating.value = false
  }
}
</script>

<template>
  <AppOverlay v-if="open" v-model="open" :title="t('app_update_title')" width="440px" :busy="updating" :close-on-click-modal="false">
    <p class="app-update-description">{{ t('app_update_description') }}</p>
    <p v-if="failed" class="app-update-error" role="alert">{{ t('app_update_failed') }}</p>
    <template #footer>
      <div class="app-update-actions">
        <el-button :disabled="updating" @click="open = false">{{ t('app_update_later') }}</el-button>
        <el-button type="primary" :loading="updating" @click="updateNow">{{ t('app_update_now') }}</el-button>
      </div>
    </template>
  </AppOverlay>
</template>

<style scoped>
.app-update-description { color: var(--app-muted); font-size: 16px; line-height: 1.6; }
.app-update-error { margin-top: 16px; color: var(--el-color-danger); }
.app-update-actions { display: flex; flex-wrap: wrap; gap: 12px; }
.app-update-actions .el-button { flex: 1; margin: 0; min-height: 48px; }
</style>
